import { useCallback, useState } from "react";
import { useDeleteReportColumn } from "@/queries";
import { ReportColumn } from "@/types/evaluate";
import { useAuth } from "@/context/auth-context";

interface UseColumnDeletionProps {
  reportId: number;
}

export const useColumnDeletion = ({ reportId }: UseColumnDeletionProps) => {
  const userToken = useAuth()?.userToken || "";
  const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] =
    useState(false);
  const { mutate: deleteColumn } = useDeleteReportColumn(userToken, reportId);

  const handleDeleteColumn = useCallback((column: ReportColumn) => {
    if (column.id && column.id !== undefined) {
      setIsDeleteConfirmationOpen(true);
    }
  }, []);

  const handleConfirmDelete = useCallback(
    (column: ReportColumn) => {
      if (column.id) {
        deleteColumn(column.id);
        setIsDeleteConfirmationOpen(false);
      }
    },
    [deleteColumn],
  );

  const handleCancelDelete = useCallback(() => {
    setIsDeleteConfirmationOpen(false);
  }, []);

  return {
    isDeleteConfirmationOpen,
    setIsDeleteConfirmationOpen,
    handleDeleteColumn,
    handleConfirmDelete,
    handleCancelDelete,
  };
};
